<template>
  <div class="page-details-membre" data-model-id="3141:822">
    <div class="background-image-wrapper">
      <div class="background-image">
          <img
            class="freepik-expand"
            alt="Freepik expand"
            src="/img/freepik-green-long-grass.png"
          />
        <div class="background-overlay" /> 
        <div class="background" />
      </div>
    </div>
    <div class="main-container">
      <header>
        <div class='burger-wrapper' v-show="tmode || mmode">
          <button class="burger-button" @click="toggleMobileMenu">
            <div class='line1' :class="{ 'active': mobileMenuOpen }"></div>
            <div class='line2' :class="{ 'active': mobileMenuOpen }"></div>
          </button>
        </div>
        
        <div class="navbar" v-show="wsmode">
          <router-link to="/" class="navbar-item">Accueil</router-link>
          <router-link to="/about" class="navbar-item">Symabio</router-link>
          <router-link to="/pagemembres" class="navbar-item">Membres</router-link>
          <router-link to="/reglement" class="navbar-item">Réglementations</router-link>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="closeMobileMenu"></div>
        <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }" v-show="tmode || mmode">
          <div class="mobile-menu-header">
            <img src="/img/logo-symabio.png" alt="Logo Symabio" class="mobile-logo" />
          </div>
          <div class="mobile-menu-links">
            <router-link to="/" class="mobile-navbar-item" @click="closeMobileMenu">Accueil</router-link>
            <router-link to="/about" class="mobile-navbar-item" @click="closeMobileMenu">Symabio</router-link>
            <router-link to="/pagemembres" class="mobile-navbar-item" @click="closeMobileMenu">Membres</router-link>
            <router-link to="/reglement" class="mobile-navbar-item" @click="closeMobileMenu">Réglementations</router-link>
          </div>
          <div class="mobile-menu-footer">
            <div class="social-icons">
              <a href="#" class="social-icon"><img src="/img/gg-facebook.svg" alt="Facebook"></a>
              <a href="#" class="social-icon"><img src="/img/formkit-linkedin.svg" alt="LinkedIn"></a>
              <a href="#" class="social-icon"><img src="/img/akar-icons-instagram-fill.svg" alt="Instagram"></a>
            </div>
          </div>
        </div>

        <router-link to="/" class="logo">
          <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          />
        </router-link>
      </header>
      <div class="content-flex">
        <div class="subtitle">Les membres de Symabio</div>
        <div class="searchbar">
          <div class="input-container">
            <input 
              type="text" 
              placeholder="Recherche..."
              v-model="searchQuery"
              @input="handleSearchInput"
              @focus="showSearchResults = true"
            />
            <div v-if="showSearchResults && (searchResults.length > 0 || productResults.length > 0)" class="search-results-container">
              <!-- Products Section -->
              <div v-if="productResults.length > 0" class="search-section products-section">
                <div class="search-section-title">🌿 PRODUITS BIO</div>
                <div class="search-results-wrapper">
                  <ul class="search-results-list">
                    <li 
                      v-for="result in productResults" 
                      :key="`product-${result.memberNumero}-${result.productName}`"
                      @click="navigateToMember(result.memberNumero)"
                      class="product-item"
                    >
                      <div class="product-content">
                        <img 
                          v-if="result.productImage"
                          :src="`/produits/${result.memberNumero}/${result.productImage}`"
                          :alt="result.productName"
                          class="product-image"
                          @error="handleProductImageError($event)"
                        />
                        <div v-else class="product-image-placeholder">
                          <span>📦</span>
                        </div>
                        <div class="product-text">
                          <span class="product-name">{{ result.productName }}</span>
                          <span class="member-name">de {{ result.memberName }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              
              <!-- Members Section -->
              <div v-if="searchResults.length > 0" class="search-section members-section">
                <div class="search-section-title">🏢 ENTREPRISES</div>
                <div class="search-results-wrapper">
                  <ul class="search-results-list">
                    <li 
                      v-for="result in searchResults" 
                      :key="result.Numero"
                      @click="navigateToMember(result.Numero)"
                    >
                      {{ result['Nom de la société'] }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="search-button" @click="performSearch">
            <div class="mingcute-search-line">
              <img class="icon-search" alt="Search" src="/img/group-1.png" height="24"/>
            </div>
          </div>
        </div>
      </div>
      <!-- <ZonesAndProducts /> -->
      <div class="divider"></div>
      <CardMembreExpanded v-if="selectedMembre" :membre="selectedMembre" />
      
    </div>
  </div>
</template>

<script>
import ZonesAndProducts from "./PageMembres/sections/ZonesAndProducts.vue";
import CardMembreExpanded from "./PageDetailsMembre/sections/CardMembreExpanded.vue";
import membres from "@/membres.json";
import productsZonesData from "@/products-zones.json"; // Import products and zones data

export default {
  name: "PageDetailsMembre",
  components: {
    ZonesAndProducts,
    CardMembreExpanded,
  },
  data() {
    return {
      membresList: membres, // Renamed from allMembers for clarity, still holds all members
      selectedMembre: null,
      searchQuery: '',
      searchResults: [],
      productResults: [],
      showSearchResults: false,
      productsZones: productsZonesData, // Store products and zones data
      mobileMenuOpen: false,
    };
  },
  created() {
    this.fetchMembreData();
  },
  watch: {
    '$route.params.id': 'fetchMembreData'
  },
  methods: {
    fetchMembreData() {
      const numeroParam = this.$route.params.id;
      if (numeroParam) {
        const numero = parseInt(numeroParam);
        this.selectedMembre = this.membresList.find(
          (membre) => membre.Numero === numero
        );
      } else {
        this.selectedMembre = null; // Handle cases where ID might be missing
      }
       // Clear search when navigating to a new member or if ID is invalid
      this.searchQuery = '';
      this.searchResults = [];
      this.productResults = [];
      this.showSearchResults = false;
    },
    handleSearchInput() {
      if (this.searchQuery.length > 1) {
        this.performSearch();
        this.showSearchResults = true;
      } else {
        this.searchResults = [];
        this.productResults = [];
        this.showSearchResults = false;
      }
    },
    performSearch() {
      if (!this.searchQuery) {
        this.searchResults = [];
        this.productResults = [];
        this.showSearchResults = false;
        return;
      }
      const lowerQuery = this.searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      
      // Search in members (existing functionality)
      this.searchResults = this.membresList.filter(member => {
        const nom = (member['Nom de la société'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        // Only search by company name
        return nom.includes(lowerQuery);
      });

      // Search in products from products-zones.json
      this.productResults = [];
      this.productsZones.forEach(member => {
        if (member['Produits BIO'] && Array.isArray(member['Produits BIO'])) {
          member['Produits BIO'].forEach(product => {
            const productName = product.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            
            // Only search by product name, not member name
            const productMatches = productName.startsWith(lowerQuery) || 
                                 productName.includes(' ' + lowerQuery) ||
                                 productName === lowerQuery;
            
            if (productMatches) {
              // Find matching product image - much more precise matching
              let productImage = null;
              if (member['Images Produits'] && Array.isArray(member['Images Produits'])) {
                // Look for image that specifically matches this product
                productImage = member['Images Produits'].find(imageName => {
                  const imageNameLower = imageName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  const productNameLower = product.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                  
                  // Remove common words and get key product name parts
                  const productKeywords = productNameLower.split(' ').filter(word => 
                    word.length > 2 && !['de', 'du', 'des', 'le', 'la', 'les', 'et', 'ou'].includes(word)
                  );
                  
                  // Check if image name contains the main product keywords
                  if (productKeywords.length > 0) {
                    const mainKeyword = productKeywords[0]; // Use the first significant word
                    return imageNameLower.includes(mainKeyword) && 
                           (imageNameLower.includes(`${member['Numero']}-${mainKeyword}`) ||
                            imageNameLower.includes(`-${mainKeyword}`) ||
                            imageNameLower.startsWith(mainKeyword));
                  }
                  
                  return false;
                });
              }
              
              this.productResults.push({
                productName: product,
                memberName: member['Nom'],
                memberNumero: member['Numero'],
                zone: member['Zone'],
                productImage: productImage
              });
            }
          });
        }
      });

      this.showSearchResults = this.searchResults.length > 0 || this.productResults.length > 0;
    },
    navigateToMember(numero) {
      if (numero) {
        // Check if already on the details page for this member to avoid redundant navigation
        if (this.selectedMembre && this.selectedMembre.Numero === numero) {
            this.showSearchResults = false;
            this.searchQuery = '';
            this.searchResults = [];
            return; // Already on this member's page
        }
        this.$router.push(`/detailsMembres/${numero}`);
        // fetchMembreData will be called by the route watcher, which will also clear search
      }
    },
    // Add a method to handle product image errors
    handleProductImageError(event) {
      // Hide the image and show placeholder when image fails to load
      event.target.style.display = 'none';
      const placeholder = event.target.nextElementSibling;
      if (placeholder && placeholder.classList.contains('product-image-placeholder')) {
        placeholder.style.display = 'flex';
      }
    },
    handleClickOutside(event) {
      const searchbarElement = this.$el.querySelector('.searchbar .input-container');
      if (searchbarElement && !searchbarElement.contains(event.target)) {
         this.showSearchResults = false;
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() { 
    document.removeEventListener('click', this.handleClickOutside);
  },
  props:{
    wsmode:{
      type: Boolean,
      default: false
    },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.page-details-membre {
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
}
.page-details-membre header{
  /* background: linear-gradient(to bottom,#e6e3b5,#e6e3b5) ; */
  background: linear-gradient(to right, #c5c69c, #cdc99c, #ceca9c) ;
  /* background: #ceca9c ; */
  position: fixed;
  height: 120px;
  top:0;
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 99;

}

.page-details-membre .burger-wrapper {
  z-index: 1000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.page-details-membre .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.page-details-membre .line1,.page-details-membre .line2{
  border-radius: 2px;
  background: #3b723e;
  height: 3.1px;
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.page-details-membre .line1{
  width: 40px;
}
.page-details-membre .line2{
  width: 30px;
}

.page-details-membre .line1.active {
  transform: rotate(45deg) translate(6px, 6px);
}
.page-details-membre .line2.active {
  transform: rotate(-45deg) translate(7px, -7px);
  width: 40px;
}

/* Mobile Menu */
.page-details-membre .mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.page-details-membre .mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #fff;
  z-index: 999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
}

.page-details-membre .mobile-menu.active {
  right: 0;
}

.page-details-membre .mobile-menu-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.page-details-membre .mobile-logo {
  height: 60px;
  width: auto;
}

.page-details-membre .mobile-menu-links {
  flex: 1;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.page-details-membre .mobile-navbar-item {
  display: block;
  padding: 16px 24px;
  color: #000;
  text-decoration: none;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s ease;
}

.page-details-membre .mobile-navbar-item:hover {
  background-color: #f8f9fa;
}

.page-details-membre .mobile-navbar-item.router-link-active {
  background-color: #3b723e;
  color: white;
}

.page-details-membre .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #eee;
}

.page-details-membre .social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.page-details-membre .social-icon {
  display: block;
  width: 32px;
  height: 32px;
}

.page-details-membre .social-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Global no-scroll class */
.no-scroll {
  overflow: hidden;
}
/* header logo navbar  */
.page-details-membre .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.page-details-membre .navbar-item {
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  /* margin-top: -1.00px; */
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.page-details-membre .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
}

.page-details-membre .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.page-details-membre .background-image-wrapper {
  position: fixed;
  background: #e6e3b5;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: -999;
}

.page-details-membre .background-image {
  height: 100%;
}
.page-details-membre .freepik-expand {
  opacity: 0.24;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}

.page-details-membre .background-overlay {
  background: #01010114;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.page-details-membre .background {
  mix-blend-mode: multiply;
  background: #e6e3b57d;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}

.page-details-membre .main-container{
  /* background-color: white; */
  padding-top: 32px;
  height: 100%;
  width: 100vw;
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  /* overflow-x: hidden; */
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.page-details-membre .overlap::-webkit-scrollbar {
  width: 8px;
}

.page-details-membre .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.page-details-membre .overlap::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}
.page-details-membre .content-flex {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 20vh 8vw 24px 8vw;
}
.page-details-membre .subtitle {
  color: #3b723e;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}

.page-details-membre .searchbar {
  /* Ensure z-index is high enough if other elements overlap */
  z-index: 1; /* Increased z-index */
  align-items: center;
  display: flex;
  gap: 6px;
  width: 36%;
  /* align-items: center; */ /* Redundant */
  /* display: flex; */ /* Redundant */
  gap:12px;
  position: relative; /* Crucial for positioning the results list */
}

.page-details-membre .input-container {
  width: -webkit-fill-available;
  position: relative; /* Ensure this container can be a reference for absolute positioning */
}
.page-details-membre .input-container input {
  border: none;
  background: #e1e6d5cc; /* Fond un peu vert */
  /* border-radius: 16px; */
  width: -webkit-fill-available;
  height: 64px;
  font-size: 20px;
  font-weight: 300;
  color: #3b723e;
  text-indent: 24px;
  outline-color:  #72703b ;
  outline-width: 2px;
  position: relative; /* For positioning the results list */
}
.page-details-membre .search-results-list {
    list-style-type: none;
    margin-top: 0px;
    margin-left: -1px;
    padding: 0px;
    /* margin: 0; */
    /* position: absolute; */
    background-color: #fffde5cc;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 16px 16px;
    width: calc(100% - -2px);
    max-height: 207px;
    overflow-y: auto;
}

.page-details-membre .search-results-list li {
  padding: 10px 24px; 
  cursor: pointer;
  color: #3b723e;
  border-bottom: 1px solid #eee; 
}

.page-details-membre .search-results-list li:last-child {
  border-bottom: none;
}

.page-details-membre .search-results-list li:hover {
  background-color: #e6e3b5;
}

/* Enhanced Search Styles - copied from PageMembres */
.page-details-membre .search-results-container {
  position: absolute;
  width: 508px;
  top: 100%;
  left: -1px;
  right: 0;
  background-color: #e1e6d5cc;
  border: 1px solid #ccc;
  border-top: none;
      border-radius: 0 0 0 0;
    max-height: 535px;
  overflow-y: visible;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.page-details-membre .search-section {
  margin-bottom: 221px;
}

.page-details-membre .members-section {
  border-top: 2px solid #f0f0f0;
}

.page-details-membre .search-results-wrapper {
  background-color: #ffffff;
  overflow: hidden;
}

.page-details-membre .search-section-title {
  padding: 14px 24px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.page-details-membre .products-section .search-section-title {
  color: #000000;
}

.page-details-membre .members-section .search-section-title {
  background: linear-gradient(135deg, #3b723e, #4e8b52);
  color: #ffffff;
}

.page-details-membre .search-results-list li {
  padding: 14px 24px;
  cursor: pointer;
  color: #3b723e;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.2s ease;
  position: relative;
}

.page-details-membre .product-item .search-results-list li,
.page-details-membre .product-item {
  padding: 12px 24px;
}

.page-details-membre .product-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.page-details-membre .product-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.page-details-membre .product-image-placeholder {
  width: 40px;
  height: 40px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  flex-shrink: 0;
}

.page-details-membre .product-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.page-details-membre .search-results-list li:last-child {
  border-bottom: none;
}

.page-details-membre .products-section .search-results-list li:hover {
  background-color: #f1f8e9;
  border-left: 4px solid #4caf50;
  padding-left: 20px;
}

.page-details-membre .members-section .search-results-list li:hover {
  background-color: #f3f7f4;
  border-left: 4px solid #3b723e;
  padding-left: 20px;
}

.page-details-membre .product-name {
  font-weight: 600;
  color: #2e7d32;
  font-size: 14px;
}

.page-details-membre .member-name {
  font-size: 11px;
  color: #757575;
  font-style: italic;
  margin-left: 0;
}

.page-details-membre .input-container input::placeholder{
  color: #3b723e;
  font-weight: 200;
}

.page-details-membre .search-button {
  background: #3b723e;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  width: 72px;
}

.page-details-membre .mingcute-search-line {
  height: 24px;
  position: relative;
  width: 24px;
}
.page-details-membre .divider{
  height: 4vh;
}

@media (max-height: 1200px){
  .page-details-membre .freepik-expand {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}
@media (max-width: 773px){
  .page-details-membre .content-flex {
    margin: 132px 6vw 24px 6vw;
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
  }
  .page-details-membre .subtitle {
    font-size: 32px;
    width: -webkit-fill-available;
  }
  .page-details-membre .searchbar {
    width: -webkit-fill-available;
  }
}

/* Additional Mobile Responsive Styles */
@media (max-width: 1024px) {
  .page-details-membre .main-container {
    overflow-x: hidden;
  }
  
  .page-details-membre .content-flex {
    margin: 140px 4vw 24px 4vw;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    overflow: visible;
  }
  
  .page-details-membre .subtitle {
    font-size: 6vw;
    width: 100%;
    text-align: center;
    white-space: normal;
  }
  
  .page-details-membre .searchbar {
    width: 100%;
    max-width: 500px;
    overflow: visible;
  }
  
  .page-details-membre .search-results-container {
    width: 100%;
    left: 0;
    right: 0;
  }
}

@media (max-width: 773px) {
  .page-details-membre .content-flex {
    margin: 132px 6vw 24px 6vw;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
  
  .page-details-membre .subtitle {
    font-size: 28px;
    width: 100%;
    text-align: center;
    white-space: normal;
  }
  
  .page-details-membre .searchbar {
    width: 100%;
    max-width: 400px;
  }
  
  .page-details-membre .input-container input {
    height: 56px;
    font-size: 18px;
  }
  
  .page-details-membre .search-button {
    height: 54px;
    width: 64px;
  }
}

@media (max-width: 480px) {
  .page-details-membre .content-flex {
    margin: 132px 4vw 16px 4vw;
    gap: 8px;
  }
  
  .page-details-membre .subtitle {
    font-size: 24px;
    text-align: center;
  }
  
  .page-details-membre .searchbar {
    width: 100%;
    max-width: 350px;
  }
  
  .page-details-membre .input-container input {
    height: 52px;
    font-size: 16px;
    text-indent: 20px;
  }
  
  .page-details-membre .search-button {
    height: 50px;
    width: 60px;
  }
  
  .page-details-membre .search-results-container {
    max-height: 250px;
    border-radius: 0 0 12px 12px;
  }
  
  .page-details-membre .search-section-title {
    padding: 12px 20px;
    font-size: 11px;
  }
  
  .page-details-membre .search-results-list li {
    padding: 12px 20px;
  }
  
  .page-details-membre .product-content {
    gap: 8px;
  }
  
  .page-details-membre .product-image,
  .page-details-membre .product-image-placeholder {
    width: 32px;
    height: 32px;
  }
  
  .page-details-membre .divider {
    height: 2vh;
  }
}
</style>